import * as React from 'react';
import { NumberField, Show, ShowProps, SimpleShowLayout, TextField, UrlField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const TrainingMenuShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="note" label="NOTE"/>
				<UrlField source="menuUrl" label="MENU_FILE"/>
				<TranslateField source="type" label="TYPE"/>
				<NumberField source="fromBMR" label="FROM_BMR"/>
				<NumberField source="toBMR" label="TO_BMR"/>
			</SimpleShowLayout>
		</Show>
	);
};
